// @ts-nocheck
class WIimage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadImage();
        this.openProZoom();
        this.closeProZoom();
        document.addEventListener('imgLoad', ()=>{
            this.loadImage();
        })
    }

    // load image on intersection 
    loadImage() {
    const lazyImage = this.querySelector("img");
    if (!lazyImage) return;

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const img = entry.target;

            if (img.dataset.src) {
                img.src = img.dataset.src;
            }

            if (img.dataset.srcset) {
                img.srcset = img.dataset.srcset;
            }

            if (img.dataset.sizes) {
                img.sizes = img.dataset.sizes;
            }

            img.classList.add("WI_loaded");
            img.classList.remove("WI_lazy");

            observer.unobserve(img);
        });
    }, {
        rootMargin: "400px"
    });

    observer.observe(lazyImage);
}

    // zoom feature open
    openProZoom() {
        let zoomEnable = this.querySelector('[data-proImg]');
        if (zoomEnable) {
            this.addEventListener('click', (e)=>{
                document.querySelector('.WI_proZoomPop_main').style.display = "block";
                let id = `WI_img_zoom_${e.target.dataset.mediaid}_id`;
                let thumbId = `WI_img_zoomThumb_${e.target.dataset.mediaid}_id`;
                setTimeout(() => {
                    this.scrollToElementWithPercentOffset(id);
                    this.zoomImgThumbClick(thumbId);
                }, 10);
            });
        }
    }

    closeProZoom() {
        document.querySelector('.WI_proZoomPop_headerLeft')?.addEventListener('click', ()=>{clsoe()});
        document.querySelectorAll('.WI_proZoomPop_in_mainImg img')?.forEach(i => {
            i.addEventListener('click', ()=>{clsoe()});
        });
        function clsoe() {
            document.querySelector('.WI_proZoomPop_main').style.display = "none";
            document.querySelectorAll('.WI_proZoomPop_thumb').forEach(t => {
                t.style.opacity = "0.5";
            });
        }
    }

    scrollToElementWithPercentOffset(id) {
          let container = document.querySelector('.WI_proZoomPop_in_mainImg');
        let targeT = document.getElementById(id);
  

  if (container && targeT) {
    let containerRect = container.getBoundingClientRect();
    let targetRect = targeT.getBoundingClientRect();

    let targetOffsetTop = targetRect.top - containerRect.top + container.scrollTop;
    let offsetInPixels = (1 / 100) * container.clientHeight;

    container.scrollTop = targetOffsetTop - offsetInPixels; // Instant scroll, no animation
  } else {
    console.warn('Container or target not found:');
  }
    }

    zoomImgThumbClick(id) {
        let zoomElement = document.getElementById(id);
        zoomElement.style.opacity = '1';
        let thumbImg = document.querySelectorAll('.WI_proZoomPop_thumb');
        for (let i = 0; i < thumbImg.length; i++) {
            thumbImg[i].addEventListener('click', (e)=>{
                thumbImg.forEach(t => {
                    t.style.opacity = "0.5";
                });
                thumbImg[i].style.opacity = "1";
                let thumbId = `WI_img_zoom_${e.target.dataset.mediaid}_id`;
                this.scrollToElementWithPercentOffset(thumbId);

            });
        }
    }
}

customElements.define('wi-image', WIimage);